const Play = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.62197 1.18373C3.7071 0.591751 2.5 1.24844 2.5 2.33814V9.66185C2.5 10.7515 3.70709 11.4082 4.62197 10.8163L10.2812 7.1544C11.1186 6.61257 11.1186 5.38741 10.2812 4.84558L4.62197 1.18373Z"
        fill="#225AEA"
      />
    </svg>
  )
}

export default Play
